import React from "react"
import { conditionalLinkTarget } from "../utilities"

const MConditionalLink = props => {
  const external_target = conditionalLinkTarget(props.link, props.link_obj)

  return (
    <a href={props.link} {...external_target}>
      {props.link_text}
    </a>
  )
}

export default MConditionalLink
